<script setup lang="ts">
import { app } from '@/composition/app';

defineProps({
  loading: { type: Boolean, required: false },
})
</script>

<template>
  <div
    id="post-comment-editor"
    class="z-11 px-3 flex-shrink-0 bg-communities-background"
    :class="app.state.isMobile ? 'fixed w-full' : 'sticky'"
    style="z-index: 11"
  >
    <slot name="comment-editor" />
  </div>
</template>
